import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const StickyHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('platform');

  const navigationItems = [
    { id: 'platform', label: 'Платформа', offset: 0 },
    { id: 'features', label: 'Возможности', offset: 0 },
    { id: 'clients', label: 'Клиенты', offset: 0 },
    { id: 'pricing', label: 'Цены', offset: 0 },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);

      const sections = navigationItems?.map(item => ({
        id: item?.id,
        element: document.getElementById(item?.id),
      }));

      const scrollPosition = window.scrollY + 100;

      for (let i = sections?.length - 1; i >= 0; i--) {
        const section = sections?.[i];
        if (section?.element && section?.element?.offsetTop <= scrollPosition) {
          setActiveSection(section?.id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element?.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${
          isScrolled ? 'glassmorphism-strong shadow-glass' : 'bg-transparent'
        }`}
      >
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 sm:h-20">
            <div className="flex items-center">
              <div className="flex items-center space-x-2 sm:space-x-3 cursor-pointer" onClick={() => scrollToSection('platform')}>
                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-gradient-to-br from-primary to-accent flex items-center justify-center neon-glow-primary">
                  <span className="text-black font-bold text-lg sm:text-xl">С</span>
                </div>
                <span className="text-base sm:text-xl font-bold text-foreground">СФЕРА CRM</span>
              </div>
            </div>

            <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
              {navigationItems?.map((item) => (
                <button
                  key={item?.id}
                  onClick={() => scrollToSection(item?.id)}
                  className={`text-xs lg:text-sm font-medium transition-colors duration-250 hover:text-primary ${
                    activeSection === item?.id ? 'text-primary' : 'text-muted-foreground'
                  }`}
                >
                  {item?.label}
                </button>
              ))}
              <Button
                variant="default"
                size="default"
                onClick={() => scrollToSection('demo')}
                className="neon-glow-primary text-xs lg:text-sm"
              >
                Демо
              </Button>
            </div>

            <button
              className="md:hidden p-2 rounded-lg glassmorphism hover:bg-muted/50 transition-colors touch-manipulation"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={20} className="sm:w-6 sm:h-6" color="var(--color-foreground)" />
            </button>
          </div>
        </nav>
      </header>
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-[90] md:hidden">
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setIsMobileMenuOpen(false)}
          />
          <div className="absolute top-16 sm:top-20 left-0 right-0 glassmorphism-strong border-t border-border mx-3 sm:mx-4 rounded-lg shadow-glass animate-slide-up">
            <div className="flex flex-col p-3 sm:p-4 space-y-2 max-h-[calc(100vh-5rem)] overflow-y-auto">
              {navigationItems?.map((item) => (
                <button
                  key={item?.id}
                  onClick={() => scrollToSection(item?.id)}
                  className={`text-left px-3 sm:px-4 py-2.5 sm:py-3 rounded-lg text-sm font-medium transition-all duration-250 touch-manipulation ${
                    activeSection === item?.id
                      ? 'bg-primary/10 text-primary border border-primary/20' :'text-muted-foreground hover:bg-muted/50 hover:text-foreground'
                  }`}
                >
                  {item?.label}
                </button>
              ))}
              <Button
                variant="default"
                size="default"
                fullWidth
                onClick={() => scrollToSection('demo')}
                className="mt-2 neon-glow-primary text-sm touch-manipulation"
              >
                Демо
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StickyHeader;